import React, { useEffect, useState, useMemo, useContext } from 'react';
import { useWindowDimensions } from '../../../common/utils/windowDimensions';
import T from '../../../common/components/T';
import AccordionSingle from '../../../widgets/accordionSingle/AccordionSingle';
import { handleClick, getItemMenu } from '../helpers';
import UserContext, { UserProfileContext } from '../../../common/utils/getContext';
import Link from 'next/link';
import { A } from '../../../hybrid/wrappers';
import { getDocumentByCountry } from '../../../common/utils/utils';

const FooterMenu = ({ compStyles, topLevelDomain }) => {
    const { lang, menu, localization } = useContext(UserContext);

    const widthDimensions = useWindowDimensions();
    const { roles = [], profileData } = useContext(UserProfileContext) || {};

    const [mobile, setMobile] = useState(false);
    useEffect(() => {
        widthDimensions < 992 ? setMobile(true) : setMobile(false);
    }, [widthDimensions]);

    const footerMenu = useMemo(() => getItemMenu(menu?.footer, roles, lang), [roles, menu?.footer, lang]);

    const userCountryTag = useMemo(() => {
        if (topLevelDomain == 'ru') {
            return 'ru';
        } else if (topLevelDomain == 'kz') {
            return 'kz';
        } else {
            if (profileData?.country?.country) {
                return profileData?.country?.country;
            }
            return localization?.country?.code;
        }
    }, [localization, profileData, topLevelDomain]);
    return (
        <>
            {mobile
                ? footerMenu.map((elem, id) => (
                      <div key={`footerMenu_${id}`} className={compStyles.footerMobMenuItemWrap}>
                          <AccordionSingle
                              title={<div className={compStyles.footerAccordionTitleMob}>{elem.title}</div>}
                              key={`accordion${id}`}
                              arrowDirection='right'
                              customStyles={compStyles}
                              icons={{
                                  opened: 'minus',
                                  closed: 'plus'
                              }}
                          >
                              <div>
                                  {elem.submenu.map((el, idx) => (
                                      <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${idx}`}>
                                          {el.type === 'outLink' ? (
                                              <p className={compStyles.officeMenuItemTextP}>
                                                  <A
                                                      className={compStyles.itemMenuStyle}
                                                      href={`https://${el.asLink}`}
                                                      target={el?.target ? '_blank' : '_self'}
                                                  >
                                                      {el.title}
                                                  </A>
                                              </p>
                                          ) : el.type === 'link' ? (
                                              <A
                                                  className={compStyles.itemMenuStyle}
                                                  target={el?.target ? '_blank' : '_self'}
                                                  href={`${el.asLink}`}
                                              >
                                                  {el.title}
                                              </A>
                                          ) : (
                                              <p
                                                  className={compStyles.itemMenuStyle}
                                                  onClick={(e) => handleClick(e, el, () => {})}
                                              >
                                                  {el.title}
                                              </p>
                                          )}
                                      </div>
                                  ))}
                                  {id === 2 ? (
                                      <>
                                          <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_11`}>
                                              <Link
                                                  className={compStyles.itemMenuStyle}
                                                  target={'_blank'}
                                                  href={`/${getDocumentByCountry(userCountryTag, 'payment_rules')}`}
                                                  style={{ whiteSpace: 'unset' }}
                                              >
                                                  <T textName='footer-link-payment' defaultStr='Оплата' />
                                              </Link>
                                          </div>
                                          <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_12`}>
                                              <Link
                                                  className={compStyles.itemMenuStyle}
                                                  target={'_blank'}
                                                  href={`/${getDocumentByCountry(userCountryTag, 'delivery')}`}
                                                  style={{ whiteSpace: 'unset' }}
                                              >
                                                  <T textName='footer-link-delivery' defaultStr='Доставка' />
                                              </Link>
                                          </div>
                                          <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_13`}>
                                              <Link
                                                  className={compStyles.itemMenuStyle}
                                                  target={'_blank'}
                                                  href={`/${getDocumentByCountry(
                                                      userCountryTag,
                                                      'return_and_exchange_of_goods'
                                                  )}`}
                                                  style={{ whiteSpace: 'unset' }}
                                              >
                                                  <T
                                                      textName='footer-link-return-and-exchange-of-goods'
                                                      defaultStr='Возврат и обмен товара'
                                                  />
                                              </Link>
                                          </div>
                                          <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_14`}>
                                              <Link
                                                  className={compStyles.itemMenuStyle}
                                                  target={'_blank'}
                                                  href={`/${getDocumentByCountry(userCountryTag, 'oferta')}`}
                                                  style={{ whiteSpace: 'unset' }}
                                              >
                                                  <T textName='footer-link-ru-5' defaultStr='Оферта' />
                                              </Link>
                                          </div>
                                          {/*<div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_8`}>*/}
                                          {/*    <Link*/}
                                          {/*        className={compStyles.itemMenuStyle}*/}
                                          {/*        target={'_blank'}*/}
                                          {/*        href={*/}
                                          {/*            topLevelDomain == 'ru'*/}
                                          {/*                ? '/docs/distributor_agreement_ru.pdf'*/}
                                          {/*                : '/docs/distributor_agreement_com.pdf'*/}
                                          {/*        }*/}
                                          {/*        style={{ whiteSpace: 'unset' }}*/}
                                          {/*    >*/}
                                          {/*        <T textName='footer-link-ru-72' defaultStr='Дистрибьюторское соглашение' />*/}
                                          {/*    </Link>*/}
                                          {/*</div>*/}
                                      </>
                                  ) : null}
                              </div>
                          </AccordionSingle>
                      </div>
                  ))
                : footerMenu.map((elem, id) => (
                      <div className={compStyles.footerMenuItemWrapper} key={`accordionMob${id}`}>
                          <div className={compStyles.footerAccordionTitle}>{elem.title}</div>
                          {elem.submenu.map((el, idx) => (
                              <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${idx}`}>
                                  {el.type === 'outLink' ? (
                                      <p className={compStyles.officeMenuItemTextP}>
                                          <A
                                              className={compStyles.itemMenuStyle}
                                              href={`https://${el.asLink}`}
                                              target={el?.target ? '_blank' : '_self'}
                                          >
                                              {el.title}
                                          </A>
                                      </p>
                                  ) : el.type === 'link' ? (
                                      <A
                                          className={compStyles.itemMenuStyle}
                                          target={el?.target ? '_blank' : '_self'}
                                          href={`${el.asLink}`}
                                      >
                                          {el.title}
                                      </A>
                                  ) : (
                                      <p className={compStyles.itemMenuStyle} onClick={(e) => handleClick(e, el, () => {})}>
                                          {el.title}
                                      </p>
                                  )}
                              </div>
                          ))}
                          {id === 2 ? (
                              <>
                                  <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_11`}>
                                      <Link
                                          className={compStyles.itemMenuStyle}
                                          target={'_blank'}
                                          href={`/${getDocumentByCountry(userCountryTag, 'payment_rules')}`}
                                          style={{ whiteSpace: 'unset' }}
                                      >
                                          <T textName='footer-link-payment' defaultStr='Оплата' />
                                      </Link>
                                  </div>
                                  <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_12`}>
                                      <Link
                                          className={compStyles.itemMenuStyle}
                                          target={'_blank'}
                                          href={`/${getDocumentByCountry(userCountryTag, 'delivery')}`}
                                          style={{ whiteSpace: 'unset' }}
                                      >
                                          <T textName='footer-link-delivery' defaultStr='Доставка' />
                                      </Link>
                                  </div>
                                  <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_13`}>
                                      <Link
                                          className={compStyles.itemMenuStyle}
                                          target={'_blank'}
                                          href={`/${getDocumentByCountry(userCountryTag, 'return_and_exchange_of_goods')}`}
                                          style={{ whiteSpace: 'unset' }}
                                      >
                                          <T
                                              textName='footer-link-return-and-exchange-of-goods'
                                              defaultStr='Возврат и обмен товара'
                                          />
                                      </Link>
                                  </div>
                                  <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_14`}>
                                      <Link
                                          className={compStyles.itemMenuStyle}
                                          target={'_blank'}
                                          href={`/${getDocumentByCountry(userCountryTag, 'oferta')}`}
                                          style={{ whiteSpace: 'unset' }}
                                      >
                                          <T textName='footer-link-ru-5' defaultStr='Оферта' />
                                      </Link>
                                  </div>
                                  {/*<div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_8`}>*/}
                                  {/*    <Link*/}
                                  {/*        className={compStyles.itemMenuStyle}*/}
                                  {/*        target={'_blank'}*/}
                                  {/*        href={*/}
                                  {/*            topLevelDomain == 'ru'*/}
                                  {/*                ? '/docs/distributor_agreement_ru.pdf'*/}
                                  {/*                : '/docs/distributor_agreement_com.pdf'*/}
                                  {/*        }*/}
                                  {/*        style={{ whiteSpace: 'unset' }}*/}
                                  {/*    >*/}
                                  {/*        <T textName='footer-link-ru-72' defaultStr='Дистрибьюторское соглашение' />*/}
                                  {/*    </Link>*/}
                                  {/*</div>*/}
                              </>
                          ) : null}
                          {/* {id == 1 ? (
                              topLevelDomain == 'com' ? (
                                  <>
                                      <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_5`}>
                                          <Link
                                              className={compStyles.itemMenuStyle}
                                              target={'_blank'}
                                              href={`/docs/oferta_com.pdf`}
                                              style={{ whiteSpace: 'unset' }}
                                          >
                                              <T textName='footer-link-ru-5' defaultStr='Оферта' />
                                          </Link>
                                      </div>
                                      <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_6`}>
                                          <Link
                                              className={compStyles.itemMenuStyle}
                                              target={'_blank'}
                                              href={`/docs/security_pay_bank_card_com.pdf`}
                                              style={{ whiteSpace: 'unset' }}
                                          >
                                              <T
                                                  textName='footer-link-ru-6'
                                                  defaultStr='Политика безопасности при оплате банковской картой'
                                              />
                                          </Link>
                                      </div>
                                      <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_7`}>
                                          <Link
                                              className={compStyles.itemMenuStyle}
                                              target={'_blank'}
                                              href={`/docs/confident_com.pdf`}
                                              style={{ whiteSpace: 'unset' }}
                                          >
                                              <T
                                                  textName='footer-link-ru-7'
                                                  defaultStr='Положение о конфиденциальной информации'
                                              />
                                          </Link>
                                      </div>
                                      <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_8`}>
                                          <Link
                                              className={compStyles.itemMenuStyle}
                                              target={'_blank'}
                                              href={`/docs/distributor_agreement_com.pdf`}
                                              style={{ whiteSpace: 'unset' }}
                                          >
                                              <T textName='footer-link-ru-72' defaultStr='Дистрибьюторское соглашение' />
                                          </Link>
                                      </div>
                                  </>
                              ) : (
                                  <>
                                      <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_1`}>
                                          <Link
                                              className={compStyles.itemMenuStyle}
                                              target={'_blank'}
                                              href={`/docs/oferta_ru.pdf`}
                                              style={{ whiteSpace: 'unset' }}
                                          >
                                              <T textName='footer-link-ru-1' defaultStr='Оферта' />
                                          </Link>
                                      </div>
                                      <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_2`}>
                                          <Link
                                              className={compStyles.itemMenuStyle}
                                              target={'_blank'}
                                              href={`/docs/security_pay_bank_card_ru.pdf`}
                                              style={{ whiteSpace: 'unset' }}
                                          >
                                              <T
                                                  textName='footer-link-ru-2'
                                                  defaultStr='Политика безопасности при оплате банковской картой'
                                              />
                                          </Link>
                                      </div>
                                      <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_3`}>
                                          <Link
                                              className={compStyles.itemMenuStyle}
                                              target={'_blank'}
                                              href={`/docs/confident_ru.pdf`}
                                              style={{ whiteSpace: 'unset' }}
                                          >
                                              <T
                                                  textName='footer-link-ru-3'
                                                  defaultStr='Положение о конфиденциальной информации'
                                              />
                                          </Link>
                                      </div>
                                      <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_4`}>
                                          <Link
                                              className={compStyles.itemMenuStyle}
                                              target={'_blank'}
                                              href={`/docs/agree_ru.pdf`}
                                              style={{ whiteSpace: 'unset' }}
                                          >
                                              <T
                                                  textName='footer-link-ru-4'
                                                  defaultStr='Согласие на обработку персональных данных'
                                              />
                                          </Link>
                                      </div>
                                      <div className={compStyles.footerAccordionBodyItem} key={`accordionMobItem${id}_88`}>
                                          <Link
                                              className={compStyles.itemMenuStyle}
                                              target={'_blank'}
                                              href={`/docs/distributor_agreement_ru.pdf`}
                                              style={{ whiteSpace: 'unset' }}
                                          >
                                              <T textName='footer-link-ru-71' defaultStr='Дистрибьюторское соглашение' />
                                          </Link>
                                      </div>
                                  </>
                              )
                          ) : null} */}
                      </div>
                  ))}
        </>
    );
};
export default FooterMenu;
